import React from 'react';
import {Link, Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

const Landing = ({isAuthenticated}) => {
    if (isAuthenticated) {
        return <Redirect to='/login'/>;
    }

    return (
        <div className="container">
        <section className='landing'>
            <div className='dark-overlay'>
                <div className='landing-inner'>
                    <h1 className='x-large'>Prime Private Network</h1>
                    <p className='lead'>
                        Get Invitation > Join > Create Your Own Network
                    </p>
                    <div className='buttons'>
                        <Link to='/login' className='btn btn-primary'>
                            Sign In
                        </Link>
                    </div>
                </div>
            </div>
        </section>
        </div>
    );
};

Landing.propTypes = {
    isAuthenticated: PropTypes.bool
};

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps)(Landing);
